/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ToggleJiraButton_organization$ref: FragmentReference;
declare export opaque type ToggleJiraButton_organization$fragmentType: ToggleJiraButton_organization$ref;
export type ToggleJiraButton_organization = {|
  +id: string,
  +isJiraEnabled: boolean,
  +$refType: ToggleJiraButton_organization$ref,
|};
export type ToggleJiraButton_organization$data = ToggleJiraButton_organization;
export type ToggleJiraButton_organization$key = {
  +$data?: ToggleJiraButton_organization$data,
  +$fragmentRefs: ToggleJiraButton_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ToggleJiraButton_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isJiraEnabled",
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '0789b7ac68bbdf296bfe187e0c7616b4';

module.exports = node;
